import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip, Switch, Divider } from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import DensitySmallIcon from '@mui/icons-material/DensitySmall';
import { useThemeMode } from '../../theme/ThemeModeContext';

// RC18.2 Phase 10 — light/dark toggle plus a compact-density switch, in one AppBar control.
const ThemeModeToggle = () => {
  const { mode, compact, toggleMode, setCompact } = useThemeMode();
  const [anchorEl, setAnchorEl] = useState(null);

  return (
    <>
      <Tooltip title="Display settings">
        <IconButton color="inherit" onClick={(e) => setAnchorEl(e.currentTarget)} aria-label="theme settings">
          {mode === 'dark' ? <DarkModeIcon /> : <LightModeIcon />}
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={() => setAnchorEl(null)}>
        <MenuItem onClick={toggleMode}>
          <ListItemIcon>{mode === 'dark' ? <DarkModeIcon fontSize="small" /> : <LightModeIcon fontSize="small" />}</ListItemIcon>
          <ListItemText primary={mode === 'dark' ? 'Dark mode' : 'Light mode'} secondary="Click to switch" />
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => setCompact(!compact)}>
          <ListItemIcon><DensitySmallIcon fontSize="small" /></ListItemIcon>
          <ListItemText primary="Compact density" />
          <Switch edge="end" size="small" checked={compact} onChange={(e) => setCompact(e.target.checked)} />
        </MenuItem>
      </Menu>
    </>
  );
};

export default ThemeModeToggle;
